import labelWithIcon from "./labelWithIcon";

export default `
  ${labelWithIcon}
`;
